import React from "react";

import * as Styled from "./styles";

const SignUpButton = ({ text, onClick }) => {
  return <Styled.Button onClick={onClick}>{text}</Styled.Button>;
};

export default SignUpButton;
